export enum DeviceConditionSeverity {
	High = 'HIGH',
	Moderate = 'MODERATE'
}

export interface DeviceCondition {
	severity: DeviceConditionSeverity;
	description: string;
}
